import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './two-column.module.scss';

const cx = classnames.bind(styles);

export const TwoColumn = ({ alt, colOne, colTwo }) => {
  return (
    <div className={cx({ background: true, alt })}>
      <div className={styles.container}>
        <section>{colOne}</section>
        <section>{colTwo}</section>
      </div>
    </div>
  );
};

TwoColumn.propTypes = {
  alt: PropTypes.bool,
  colOne: PropTypes.node,
  colTwo: PropTypes.node,
};
